import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/romaneio')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_venda_romaneio }) =>
                isPermissionParcialOrFull(upp_venda_romaneio),
        }),
});
